import { extractQrIdFromScan } from "../components/QRScanner";

export interface CreateTrackerScanResult {
  trackerId: string;
  extraParts: string[];
}

/** Např. 868188076931355;MPY24CR10009995;900371CFB7A5;;868188076931363;; → první část = tracker ID. */
export function parseCreateTrackerScan(text: string): CreateTrackerScanResult | null {
  const trimmed = text.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.includes(";")) {
    const parts = trimmed.split(";");
    const trackerId = parts[0]?.trim();
    if (!trackerId) {
      return null;
    }
    const extraParts = parts.slice(1).map((part) => part.trim()).filter(Boolean);
    return { trackerId, extraParts };
  }

  const uuid = extractQrIdFromScan(trimmed);
  if (uuid) {
    return { trackerId: uuid, extraParts: [] };
  }

  return { trackerId: trimmed, extraParts: [] };
}
